import React from 'react';
import { benefits } from '../data/modules';
export function Benefits() {
  return <section className="px-4 py-8" data-id="element-17" data-mp="9b5xmh3z011p">
      <div className="mx-auto max-w-4xl" data-id="element-18" data-mp="9c774h5c8fhb">
        <h2 className="text-center text-xl font-extrabold sm:text-3xl" data-id="element-19" data-mp="9di8ybf83d5s">What Will Change</h2>
        <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-20" data-mp="4icntetna2ir">
          {benefits.map(benefit => <article key={benefit.title} className="rounded-xl border border-ink-line bg-ink-panel p-4" data-id="element-21" data-mp="3vq7a7fz644iq">
              <h3 className="text-[13px] font-bold leading-tight sm:text-base" data-id="element-22" data-mp="3qsyv5o9bgglp">
                {benefit.title}
              </h3>
              <p className="mt-1 text-xs leading-snug text-ink-text sm:text-sm" data-id="element-23" data-mp="3hqxz2uptk0lm">
                {benefit.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}